<template>
  <div>
    <div class="top">
      <img class="picimg" src="@/assets/image/平台定制开发.jpg" />
    </div>
    <div style="display: flex; align-items: center" class="prompt">
      <img class="icon" src="@/assets/images/zhuye.png" />
      <span class="color858"
        >&nbsp;&nbsp;你现在的位置&nbsp;&nbsp;/&nbsp;&nbsp;首页&nbsp;&nbsp;/&nbsp;&nbsp;</span
      >
      <span>平台定制开发</span>
    </div>
    <div class="titleBox">
      <span class="title">PLATFORM CUSTOMIZATION</span>
      <span class="title1">平台定制开发</span>
      <span class="line"></span>
    </div>
    <div class="service-main">
      <section class="pc-section">
        <h2 class="pc-h2">
          <span class="pc-h2-bar"></span>
          应用介绍
        </h2>
        <p class="pc-intro">
          平台定制开发是一种按照用户特别需求和业务流程，根据用户的需求设计、开发和实现某一特定软件平台的过程。平台定制开发是针对特定需求的企业而进行定制，以满足其特定技术要求和业务流程需求，加强定制化，灵活性和安全性。平台定制开发能够为企业提供完全适用于其具体需求的解决方案，以优化其业务流程，并增加其效率。具体价值表现在以下几个方面：
        </p>
        <ol class="pc-ol">
          <li>
            <span class="pc-li-num">(1)</span>
            专业软件定制可以满足用户特定使用习惯的需求，对用户针对性更强。
          </li>
          <li>
            <span class="pc-li-num">(2)</span>
            满足用户特定功能的需求。根据需求方的需求量身打造，可以让企业最大程度的避免花冤枉钱、办无用事情况。
          </li>
          <li>
            <span class="pc-li-num">(3)</span>
            定制软件过程中，可以针对不同企业的实际情况，编制最适用、易用的软件。
          </li>
          <li>
            <span class="pc-li-num">(4)</span>
            满足用户将独特构思转化为效益的需求，给企业带去更大的经济效益。
          </li>
        </ol>
      </section>

      <section class="pc-section">
        <h2 class="pc-h2">
          <span class="pc-h2-bar"></span>
          实现步骤
        </h2>
        <div class="pc-step-paras">
          <p class="pc-step-line">
            <span class="pc-step-label">了解客户需求：</span>与客户沟通交流，详细了解客户的业务需求和要求，明确客户的定制化需求。
          </p>
          <p class="pc-step-line">
            <span class="pc-step-label">设计平台方案：</span>根据客户的业务需求和定制化需求，设计一个适合客户的平台方案，包括平台架构、功能模块、用户界面等。同时要考虑平台的可扩展性和可维护性，并与客户进行确认和协商。
          </p>
          <p class="pc-step-line">
            <span class="pc-step-label">开发平台：</span>根据平台方案，进行软件的开发和编码，包括前端开发和后端开发等。在开发过程中，需要进行代码管理、协同开发、版本控制、测试和调试等。
          </p>
          <p class="pc-step-line">
            <span class="pc-step-label">进行测试和验收：</span>在平台开发完成后，需要进行系统测试和验收，确保平台的功能能够完全满足客户的需求，并达到客户的质量标准和要求。
          </p>
          <p class="pc-step-line">
            <span class="pc-step-label">安装和部署：</span>在平台经过测试和验收后，需要进行安装和部署，在客户的系统环境中进行集成和部署，并进行培训和后期维护支持。
          </p>
          <p class="pc-step-line">
            <span class="pc-step-label">后期维护：</span>平台定制开发完成后，需要进行后期维护和支持，包括故障排除、版本升级和安全维护等。
          </p>
        </div>
      </section>

      <section class="pc-section pc-cases">
        <h2 class="pc-h2">
          <span class="pc-h2-bar"></span>
          案例介绍
        </h2>

        <!-- 1 左：数字人立绘 | 右：说明气泡在上、智算平台界面在下 -->
        <div class="pc-case pc-case--digital">
          <h3 class="pc-case-name">数字人智能交互平台</h3>
          <div class="pc-case-digital-row">
            <div class="pc-case-char-wrap">
              <img
                class="pc-case-char-img"
                src="@/assets/image/数字人.jpg"
                alt="数字人形象"
              />
            </div>
            <div class="pc-case-digital-main">
              <div class="pc-case-digital-text-wrap">
                <div class="pc-case-text pc-case-text--bubble">
                  是专门为企业安全管理场景打造的高效智能交互解决方案，它深度对接企业安全检查数据库和大模型AI智能体，实现专家级的对话体验。
                </div>
              </div>
              <div class="pc-case-img-wrap pc-case-img-wrap--dashboard">
                <img
                  class="pc-case-img pc-case-img--contain"
                  src="@/assets/image/数字人2.png"
                  alt="建筑安全质量智算平台"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- 与智慧街区数字化服务一致：浅蓝卡片 + 黄角标标题 + 交替图文 -->
        <div class="pc-case pc-case--sb">
          <div class="sb-oper-wrap">
            <section class="sb-block sb-block--oper">
              <h3 class="sb-h3">
                <span class="sb-h3-mark"></span>
                建设局数字化监管平台
              </h3>
              <p class="sb-p">
                通过采集项目相关的基础数据，在市监管工作要求的基础上，制定区一级监管应用细则，并结合分级管控的隐患库，建立起互联网模式的监管平台，并利用BIM模型的可视化效果，建立起数据驱动的数字化互联网+监管平台。
              </p>
            </section>
            <div class="sb-oper-images" aria-label="建设局数字化监管平台配图">
              <img
                class="sb-oper-img"
                src="@/assets/image/建设局.png"
                alt="建设局数字化监管平台"
              />
            </div>
          </div>
        </div>

        <div class="pc-case pc-case--sb">
          <div class="sb-security-wrap">
            <div class="sb-security-images" aria-label="自规局规后监管平台配图">
              <img
                class="sb-security-img"
                src="@/assets/image/自规平台.png"
                alt="自规局规后监管平台"
              />
            </div>
            <section class="sb-block sb-block--security">
              <h3 class="sb-h3">
                <span class="sb-h3-mark"></span>
                自规局规后监管平台
              </h3>
              <p class="sb-p">
                形成数字化「一项目一档案」依据批后监督管理刚性及弹性指标管控要求，通过三维可视化呈现方式，建立建设项目违规风险预警系统。
              </p>
            </section>
          </div>
        </div>

        <div class="pc-case pc-case--sb">
          <div class="sb-oper-wrap">
            <section class="sb-block sb-block--mgmt">
              <h3 class="sb-h3">
                <span class="sb-h3-mark"></span>
                建工安责险平台
              </h3>
              <p class="sb-p">
                根据国家及集团工作要求，对建工安责险风控服务做业务流程设计和实现，基本实现：业务信息数据化，可分析；服务记录流程化，可追溯；整改信息完整化，可管控；数据结果直观化，可预防。
              </p>
            </section>
            <div class="sb-oper-images" aria-label="建工安责险平台配图">
              <img
                class="sb-oper-img"
                src="@/assets/image/建工平台.png"
                alt="建工安责险平台"
              />
            </div>
          </div>
        </div>

        <div class="pc-case pc-case--sb">
          <div class="sb-security-wrap">
            <div class="sb-security-images" aria-label="项目数字化管理平台配图">
              <img
                class="sb-security-img"
                src="@/assets/image/项目数字平台.png"
                alt="项目数字化管理平台"
              />
            </div>
            <section class="sb-block sb-block--ai">
              <h3 class="sb-h3">
                <span class="sb-h3-mark"></span>
                项目数字化管理平台
              </h3>
              <p class="sb-p">
                通过本系统使得监理工程项目管理变得更加简单、方便，能够及时掌握工程风险，大大提高了工程管理的效率。
              </p>
            </section>
          </div>
        </div>
      </section>
    </div>
    <Bottom />
    <Right />
  </div>
</template>

<script>
import Bottom from "./bottom.vue";
import Right from "./right.vue";

export default {
  components: {
    Bottom,
    Right,
  },
};
</script>

<style lang="scss" scoped>
$pc-orange: #f29600;
$pc-step-label: #5b9bd5;
$pc-case-title: #5b9bd5;
/* 与智慧街区数字化服务案例块一致 */
$sb-blue: #5b9bd5;
$sb-yellow: #e6c229;

.service-main {
  max-width: 960px;
  margin: 0 auto 80px;
  padding: 0 40px;
  line-height: 1.8;
  font-size: 16px;
  color: #333;
}

.pc-section {
  margin-top: 40px;

  &:first-of-type {
    margin-top: 20px;
  }
}

.pc-h2 {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 700;
  color: #333;
  margin: 0 0 20px;
}

.pc-h2-bar {
  width: 4px;
  height: 22px;
  background: $pc-orange;
  margin-right: 10px;
  flex-shrink: 0;
}

.pc-intro {
  text-indent: 2em;
  margin: 0 0 16px;
}

.pc-ol {
  margin: 0;
  padding-left: 0;
  list-style: none;

  li {
    margin-bottom: 10px;
    padding-left: 0;
    text-indent: 0;
  }
}

.pc-li-num {
  font-weight: 600;
  margin-right: 4px;
}

.pc-step-paras {
  margin: 0;
}

.pc-step-line {
  margin: 0 0 14px;
  text-align: justify;
}

.pc-step-label {
  color: $pc-step-label;
  font-weight: 700;
}

.pc-cases .pc-case {
  margin-top: 36px;

  &:first-of-type {
    margin-top: 8px;
  }
}

.pc-cases .pc-case-name {
  font-size: 18px;
  font-weight: 700;
  color: $pc-case-title;
  margin: 0 0 14px;
}

.pc-case-text {
  flex: 1 1 280px;
  min-width: 0;
  padding: 16px 18px 22px;
  box-sizing: border-box;
}

/* 数字人说明框：与智慧街区案例卡片（sb-block）一致 */
.pc-case--digital .pc-case-text--bubble {
  background: rgba(91, 155, 213, 0.08);
  border: 1px solid rgba(91, 155, 213, 0.35);
  border-radius: 8px;
  box-sizing: border-box;
}

/* —— 以下与智慧街区数字化服务 `smartDigitalService.vue` 中 sb-* 一致 —— */
.sb-oper-wrap,
.sb-security-wrap,
.sb-mgmt-wrap,
.sb-ai-wrap,
.sb-twin-wrap {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  align-items: center;
  justify-items: stretch;
  gap: 24px 32px;
  width: 100%;
  max-width: 920px;
  margin: 0 auto 28px;
  min-width: 0;
}

.sb-block--oper,
.sb-block--security,
.sb-block--mgmt,
.sb-block--ai,
.sb-block--twin {
  min-width: 0;
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.sb-oper-images,
.sb-security-images {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  min-width: 0;
  padding: 4px 0;
}

.sb-oper-img,
.sb-security-img {
  display: block;
  width: 100%;
  max-width: 100%;
  height: auto;
  max-height: 280px;
  object-fit: contain;
  object-position: center center;
}

.sb-block {
  margin-bottom: 28px;
  padding: 16px 18px;
  background: rgba(91, 155, 213, 0.08);
  border: 1px solid rgba(91, 155, 213, 0.35);
  border-radius: 8px;

  &:last-child {
    margin-bottom: 0;
  }
}

.sb-h3 {
  display: flex;
  align-items: center;
  font-size: 17px;
  font-weight: 700;
  color: $sb-blue;
  margin: 0 0 12px;
}

.sb-h3-mark {
  width: 8px;
  height: 8px;
  background: $sb-yellow;
  margin-right: 8px;
  flex-shrink: 0;
}

.sb-p {
  margin: 0;
  text-align: justify;
  line-height: 1.85;
}

.pc-case-digital-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 20px;
}

.pc-case-char-wrap {
  flex: 0 0 auto;
  width: 200px;
  max-width: min(220px, 32vw);
  min-width: 0;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.pc-case-char-img {
  display: block;
  width: 100%;
  max-height: 380px;
  height: auto;
  object-fit: contain;
  border-radius: 4px;
}

.pc-case-digital-main {
  flex: 1 1 320px;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.pc-case-digital-text-wrap {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}

.pc-case-digital-text-wrap .pc-case-text--bubble {
  flex: 0 1 auto;
  max-width: min(100%, 520px);
  width: 100%;
}

.pc-case-img-wrap--dashboard {
  flex: none;
  width: 100%;
  max-height: 420px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pc-case-img-wrap {
  flex: 1 1 300px;
  min-width: 0;
  border-radius: 4px;
  overflow: hidden;
  background: #f0f4f8;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pc-case-img {
  display: block;
  width: 100%;
  height: auto;
  max-height: 440px;
  object-fit: cover;
}

.pc-case-img--contain {
  object-fit: contain;
  max-height: 440px;
}

.pc-case-img-wrap--dashboard .pc-case-img--contain {
  max-height: 420px;
}

@media (max-width: 768px) {
  .service-main {
    padding: 0 20px;
  }

  .pc-case-digital-row {
    flex-direction: column;
    align-items: center;
  }

  .pc-case-char-wrap {
    width: 180px;
    max-width: 70%;
  }

  .pc-case-char-img {
    max-height: 320px;
  }

  .pc-case-digital-text-wrap {
    justify-content: center;
  }

  .pc-case-digital-text-wrap .pc-case-text--bubble {
    max-width: 100%;
  }

  .pc-case-img-wrap--dashboard {
    max-height: none;
  }

  .sb-oper-wrap,
  .sb-security-wrap,
  .sb-mgmt-wrap,
  .sb-ai-wrap,
  .sb-twin-wrap {
    grid-template-columns: minmax(0, 1fr);
    max-width: none;
    margin-left: 0;
    margin-right: 0;
    gap: 16px;
  }

  .sb-oper-img,
  .sb-security-img {
    max-height: 240px;
  }
}
</style>
